import React from 'react';
import { Flex } from 'rebass';
import Frame from 'components/Frame';
import AddCandidateForm from 'modules/Candidates/components/AddCandidateForm';

const AddCandidate: React.FC<any> = ({ match }): JSX.Element => {
  return (
    <Frame>
      <Flex width="100%" flexDirection="column">
        <AddCandidateForm jobPostId={match.params.id} />
      </Flex>
    </Frame>
  );
};

export default AddCandidate;
